/**
 * Loader para templates JSON dinamicamente com auto-descoberta
 * Carrega automaticamente todos os templates de temas usando import.meta.glob
 */

// Auto-descoberta: carrega todos os JSONs da pasta
const modules = import.meta.glob('../themes/templates/*.json', { eager: true });

const templates = {};
for (const path in modules) {
  const tpl = modules[path].default ?? modules[path];
  if (tpl?.id) {
    templates[tpl.id] = tpl;
  }
}

/**
 * id do tema → enum ThemeType do backend (1-indexed). NÃO altere os números.
 */
export const THEME_ENUM = {
  'default': 1,
  'barbershop': 2,
  'company': 3,
  'tattoo-studio': 4,
  'beauty-salon': 5,
  'psychology': 6,
  'aesthetics': 7,
  'massage': 8,
  'dental': 9,
  'medical': 10,
  'therapy': 11,
  'teacher': 12,
  'personal-trainer': 13,
};

export const loadTemplate = async (templateId) => {
  try {
    const template = templates[templateId];
    if (!template) {
      throw new Error(`Template não encontrado: ${templateId}`);
    }
    return template;
  } catch (error) {
    console.error(`[TemplateLoader] Erro ao carregar template: ${templateId}`, error);
    throw new Error(`Falha ao carregar template: ${templateId}`);
  }
};

/**
 * Lista todos os templates disponíveis
 * Retorna o template completo para cada tema (não apenas resumo)
 * O tema 'default' ("Outros") sempre vem por último
 */
export const listAvailableTemplates = async () => {
  try {
    const all = Object.values(templates);
    
    // Separa o default dos outros, ordena alfabeticamente os outros
    const others = all
      .filter((t) => t.id !== 'default')
      .sort((a, b) => a.name.localeCompare(b.name, 'pt-BR'));
    
    // Coloca o default por último
    const def = all.find((t) => t.id === 'default');
    const result = def ? [...others, def] : others;
    
    return result;
  } catch (error) {
    console.error('[TemplateLoader] Erro ao listar templates', error);
    throw new Error('Falha ao listar templates');
  }
};
